import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import TabBar from '../../components/Tabs/TabBar';
import TabBody from '../../components/Tabs/TabBody';
import Error404 from "../Error404";
import { fetchTabContent } from '../../api';
import '../../App.css';

const PasteView = () => {
    const [tabs, setTabs] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const { id } = useParams();

    const handleTabClick = useCallback((index) => {
        setActiveTab(index);
    }, []);

    useEffect(() => {
        fetchTabContent(id)
            .then((tabContent) => {
                setTabs(tabContent);
                setActiveTab(0);
            })
            .catch((err) => {
                setError(err);
                console.error('Error fetching tab details:', err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [id]);

    if (isLoading) {
        return (
            <div className="loading-container">
                <div className="spinner" />
                <span className="loading-text">Loading paste...</span>
            </div>
        );
    }

    if (error || !tabs.length) {
        return <Error404 />;
    }

    return (
        <div className="App">
            <TabBar editDisabled={1} tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />
            <TabBody editDisabled={1} tabs={tabs} activeTab={activeTab} />
            <div className="view-status-bar">
                <span>/{id}</span>
                <span>{tabs.length} tab{tabs.length !== 1 ? 's' : ''}</span>
            </div>
        </div>
    );
};

export default PasteView;
